import axios from "@/plugins/axios";
import router from "@/router";
import toast from "@/plugins/bulmatoast";

export function login(email, password) {
    axios.defaults.headers.common["Authorization"] = "";
    localStorage.removeItem("access");

    axios.post("/customer/cabinet/login", {email: email, password: password})
        .then(response => {
            axios.defaults.headers.common['Authorization'] = "Bearer " + response.data.access_token;
            localStorage.setItem("access", response.data.access_token);
            router.push('/')
            router.go(0)
        })
        .catch((error) => {
        toast({
            message: error.response.data.detail,
            type: "is-danger",
        });
    })
}

export function logout() {
    localStorage.removeItem("access");
    router.push('/')
    router.go(0)
}